import React from 'react';
import { SvgIconName } from '../../../../components/svg-icon/model';
import {
  IAPIServiceConfigItem,
  IFavoriteTotalItem,
  IMyFavoriteItem,
  IServiceApplyConfig,
} from '../../../../model/api-modules';
import { ModalWrap } from '../../../component/modal-wrap';
import { SvgIcon } from '../../../component/svg-icon';
// import PlatformOne from '../../../../assets/svg/platform-one.svg';
// import PlatformTwo from '../../../../assets/svg/platform-two.svg';
// import PlatformThree from '../../../../assets/svg/platform-three.svg';
// import PlatformFour from '../../../../assets/svg/platform-four.svg';
import ModalRight from '../../../../assets/svg/all-product-modal-right.svg';
import {
  getLocaleLanguage,
  LanguageType,
  openURL,
  strToJson,
} from '../../../../lib';
import { useHistory } from 'react-router-dom';
import { getPathnameByGameService } from '../../lib';
import { FavoriteButton } from '../favorite-button';
import './style.scss';
import getFormatMessage from '../../../../locales/get-format-message';
import { getConfig } from '../../../../config';

interface IProps {
  readonly onCancel: () => void;
  readonly configItem: IAPIServiceConfigItem;
  readonly favoriteList: ReadonlyArray<IMyFavoriteItem>;
  readonly favoriteTotalList: ReadonlyArray<IFavoriteTotalItem>;
}

export const DescriptionModal = (props: IProps) => {
  const history = useHistory();
  const currentStoreLanguage = getLocaleLanguage() || LanguageType.en_US;
  const jsonConfig = strToJson<IServiceApplyConfig>(
    props.configItem.JsonConfig || ''
  );
  const favoriteTotalItem = props.favoriteTotalList.find(
    (item) => item.ServiceID === props.configItem.id
  );

  const onToServiceRouter = (serviceID: number) => {
    return () => {
      history.push(getPathnameByGameService(serviceID));
    };
  };

  const onClickDocLink = () => {
    if (jsonConfig) {
      const item = jsonConfig[currentStoreLanguage].docLink.find(
        (item) => item.title === getFormatMessage('product_document_title')
      );
      if (item?.url) {
        const url =
          item.url.indexOf(getConfig().consoleURL) !== -1
            ? item.url
            : `${getConfig().consoleURL}${item.url}`;
        return openURL(url, undefined, true);
      }
    }
  };

  const renderIcon = () => {
    return (
      <div className="service-icon">
        <SvgIcon
          icon={props.configItem.IconURL as SvgIconName}
          width={40}
          className="icon-blue"
        />
      </div>
    );
  };

  const renderServiceInfo = () => {
    const { configItem } = props;
    return (
      <div className="service-base-info">
        <div className="row">
          <div className="name">{configItem.Name}</div>
          <div className="category">{configItem.ParentName}</div>
          <FavoriteButton
            favoriteTotal={favoriteTotalItem?.TotalCount}
            favoriteList={props.favoriteList}
            serviceConfig={props.configItem}
            showTotal={true}
          />
        </div>
        <div className="row">
          <div className="release">{getFormatMessage('latest_release')}</div>
          <div className="version">{getFormatMessage('latest_version')}</div>
        </div>
      </div>
    );
  };

  const renderStartNowButton = () => {
    return (
      <div
        className="start-now"
        onClick={onToServiceRouter(props.configItem.id)}
      >
        {getFormatMessage('start_now')}
      </div>
    );
  };

  // const renderRowLabel = (left: string, right: React.ReactNode) => {
  //   return (
  //     <div className="row">
  //       <div className="left">{left} </div>
  //       {right}
  //     </div>
  //   );
  // };

  const renderDescription = () => {
    const jsonConfigItem = jsonConfig
      ? jsonConfig[currentStoreLanguage]
      : undefined;
    return (
      <div className="description-box">
        {/* {renderRowLabel(
          'Platform:',
          <div className="icons">
            <img src={PlatformOne} className="modal-content-platform-img" />
            <img src={PlatformTwo} className="modal-content-platform-img" />
            <img src={PlatformThree} className="modal-content-platform-img" />
            <img
              src={PlatformFour}
              className="modal-content-platform-img"
              style={{ width: 14 }}
            />
          </div>
        )}
        {renderRowLabel('Engine Versions:', 'UE4.24-4.27, 5.0-5.3')} */}
        <div className="description">{jsonConfigItem?.description}</div>
        <div className="doc-link">
          <span className="text" onClick={onClickDocLink}>
            {getFormatMessage('documentation')}
          </span>
          <img src={ModalRight} className="doc-arrow" />
        </div>
      </div>
    );
  };

  const renderContent = () => {
    return (
      <div className="service-description-modal">
        <div className="header-box">
          {renderIcon()}
          {renderServiceInfo()}
          {renderStartNowButton()}
        </div>
        {renderDescription()}
      </div>
    );
  };

  return (
    <ModalWrap
      onClose={props.onCancel}
      width="608px"
      maskClosable={true}
      className="description-modal"
    >
      {renderContent()}
    </ModalWrap>
  );
};
